/* eslint-disable max-lines-per-function, no-var, max-len, max-params */
'use strict';

angular.module('webAgro1App').controller('UsuariosCtrl', function($scope, $rootScope, $location, $routeParams, $window, $uibModal,
  Flash, UsuariosService, FuncoesService, LoadingService, MessagesService) {
  var initializeVariables = function() {
    $scope.filters = {
      mobile: UsuariosService.getUtilizaMobile()
    };

    $scope.usuarios = null;
    $scope.pages = {};
    $scope.mobileStatus = TIPOS_UTILIZA_MOBILE;
  };

  var initialize = function() {
    LoadingService.showLoading();
    $rootScope.initialize.then(function() {
      if (!$rootScope.permissions.usuario.canRead) {
        $location.path('/');
        Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
        return;
      }

      if ($routeParams.id) {
        UsuariosService.getUsuario($routeParams.id).then(function(data) {
          $scope.usuario = data;
          if (!$scope.usuario || !$scope.usuario.id) {
            setTimeout(function() {
              $window.history.back();
            }, 100);
          }
        })
          .finally(LoadingService.hideLoading);
      } else {
        initializeVariables();
        FuncoesService.listNoPaginated().then(function(data) {
          $scope.funcoes = data.data || [];
          $scope.buscarClick();
        }, function() {
          LoadingService.hideLoading();
          MessagesService.alert('Não foi possível localizar as funções.');
        });
      }
    }, $rootScope.errorRootInitialize);
  };

  $scope.getUsuarios = function() {
    LoadingService.showLoading();
    $scope.usuarios = null;
    UsuariosService.listPaginated($scope.filters).then(function(data) {
      $scope.usuarios = data.data || [];
      $scope.pages = data.pages || {};
    }, function() {
      MessagesService.alert('Não foi possível buscar os Usuários.');
    })
      .finally(LoadingService.hideLoading);
  };

  $scope.setPage = function(page) {
    var isEqual = $scope.filters.page && $scope.filters.page === page;
    if ((typeof(page) === 'undefined') || (!$scope.filters.page && page === 1) || isEqual) {
      return;
    }
    $scope.filters.page = page;
    $scope.getUsuarios();
  };

  $scope.buscarClick = function() {
    $scope.filters.page = null;
    $scope.getUsuarios();
  };

  $scope.goToIndex = function() {
    $location.path('/usuarios');
  };

  var setUrlUsuario = function(usuario, url) {
    if (usuario) {
      $location.path(`/usuarios/${ usuario.id }${url || ''}`);
    }
  };

  $scope.show = function(index) {
    setUrlUsuario($scope.usuarios[index]);
  };

  $scope.edit = function() {
    setUrlUsuario($scope.usuario, '/edit');
  };

  $scope.configNotifications = function(usuario) {
    $uibModal.open({
      templateUrl: 'views/usuarios/modal/alertas.html',
      controller: 'UsuarioAlertasCtrl',
      controllerAs: '$alerta',
      resolve: {
        usuario: usuario
      }
    });
  };

  $scope.disable = function(usuario) {
    MessagesService.confirm(`Você tem certeza que deseja desativar o usuário ${ usuario.nome_completo }?`).then(function() {
      LoadingService.showLoading();
      return UsuariosService.disable(usuario);
    })
      .then(function() {
        Flash.create(REGISTRO_SALVO_COM_SUCESSO.type, REGISTRO_SALVO_COM_SUCESSO.msg);
        $scope.getUsuarios();
      })
      .catch(function(error) {
        if (error) {
          console.error('Falha ao atualizar usuário', error);
          Flash.create(FALHA_AO_SALVAR_REGISTRO.type, FALHA_AO_SALVAR_REGISTRO.msg);
          LoadingService.hideLoading();
        }
      // else: modal recusada
      });
  };

  initialize();
});
